import { Box, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { InputField } from "src/components/atoms/input-field";
import { OnboardingFormValues } from "./utils";
import { lightPrimary, lightText } from "src/colors";
import { FEE_PER_SINGLE_USER } from "src/utils/calculate-monthly-fee";
import { PriceFormatter } from "src/components/atoms/price-formatter";

export const OnboardingDialogUsers = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<OnboardingFormValues>();

  return (
    <Box>
      <Controller
        name="numberOfUsers"
        control={control}
        defaultValue={0}
        render={({ field: { onChange, value, onBlur, ref, name }, fieldState: { error } }) => (
          <>
            <InputField
              name={name}
              label={t("onboarding:users.label")}
              value={value}
              onChange={onChange}
              type="number"
              min={0}
              error={!!error}
              helperText={error?.message}
              ref={ref}
              onBlur={onBlur}
              fullWidth
            />
            <Box sx={{ display: "flex", gap: 0.5, mt: 1, mb: 3 }}>
              <Typography color={lightText.secondary} variant="body2" sx={{ fontSize: "12px" }}>
                <b>{t("onboarding:users.monthlyFee")}</b>
              </Typography>
              <Typography
                color={lightPrimary.hoverOutlined}
                variant="body2"
                sx={{ fontSize: "12px" }}>
                <b>
                  <PriceFormatter amount={value * FEE_PER_SINGLE_USER} currency="EUR" />*
                </b>
              </Typography>
            </Box>
            <Typography color={lightText.secondary} variant="body2" sx={{ fontSize: "12px" }}>
              {t("onboarding:users.monthlyFeeDescription")}
            </Typography>
          </>
        )}
      />
    </Box>
  );
};
